export const CRM_PERMISSION_CODES = {
  CLIENTS: 'CRM.CLIENTES',
  CLIENTS_VIEW_SECTION: 'CRM.VER_SECCION_62',
  CREATE_CLIENT: 'CRM.CREAR_CLIENTE',
  DOWNLOAD_EXCEL: 'CRM.DESCARGAR_EXCEL',
  CLIENT_DETAIL: 'CRM.DETALLE_CLIENTE',
  CLIENT_DETAIL_VIEW_SECTION: 'CRM.VER_SECCION_67',
  EDIT_CLIENT: 'CRM.EDITAR_CLIENTE',
  VIEW_INACTIVE_BLOCKED_CLIENT: 'CRM.VER_CLIENTE_EN_BAJA_BLOQUEADO',
  TOGGLE_CLIENT_ACTIVE: 'CRM.ACTIVAR_INACTIVAR_CLIENTE',
  RUT_MONITORING: 'CRM.MONITOREO_DE_RUT',
  RUT_MONITORING_VIEW_SECTION: 'CRM.VER_SECCION_110',
  ADD_CLIENT: 'CRM.AGREGAR_CLIENTE',
  VIEW_CLIENT_DETAIL: 'CRM.VER_DETALLE_DE_CLIENTE',
  REMOVE_FROM_MONITORING: 'CRM.ELIMINAR_DE_MONITOREO',
  COLLECTIONS: 'CRM.COBRANZAS',
  AGENDA: 'CRM.AGENDA',
  MANAGE_AUTOMATIONS: 'CRM.GESTIONAR_AUTOMATIZACIONES',
  ACTIVATE_CLIENT: 'CRM.DETALLE_CLIENTE.ACTIVAR_CLIENTE',
  GENERAL_INFORMATION: 'CRM.DETALLE_CLIENTE.INFORMACION_GENERAL',
  CLIENT_CALLS: 'CRM.DETALLE_CLIENTE.LLAMADAS',
  CLIENT_EMAILS: 'CRM.DETALLE_CLIENTE.EMAILS',
  CLIENT_CONTRACTS: 'CRM.DETALLE_CLIENTE.CONTRATOS',
  CLIENT_DOCUMENTS: 'CRM.DETALLE_CLIENTE.DOCUMENTOS',
  CLIENT_SAC_EEPP_TASKS: 'CRM.DETALLE_CLIENTE.TAREAS_SAC_EEPP',
  CLIENT_SAC: 'CRM.DETALLE_CLIENTE.SAC',
  CLIENT_SAC_LEGACY: 'CRM.DETALLE_CLIENTE.SAC_LEGACY',
  CLIENT_EEPP: 'CRM.DETALLE_CLIENTE.EEPP',
  CLIENT_EEPP_LEGACY: 'CRM.DETALLE_CLIENTE.EEPP_LEGACY',
  CLIENT_ANALYSIS: 'CRM.DETALLE_CLIENTE.ANALISIS_DE_CLIENTE',
};
